import { IListPaginated } from '@interfaces/api/IRequestsReturn'
import { REAL_ESTATE_TYPE, REAL_ESTATE_TYPE_FILTER } from '@interfaces/realEstates/enums/realEstateType'
import { IActiveAction, IActiveActionFinish } from '@interfaces/realEstates/iActiveStatus'
import { IRealEstate, IRealEstateSummery } from '@interfaces/realEstates/iRealEstate'
import api from '@services/api/server'

export default class RealEstateService {
    public static async list(page = 1, perPage = 25, name?: string, type?: REAL_ESTATE_TYPE_FILTER): Promise<IListPaginated<IRealEstate>> {
        if (type === REAL_ESTATE_TYPE_FILTER.ALL) {
            type = undefined
        }
        if (name === '') {
            name = undefined
        }
        return (
            await api.get<IListPaginated<IRealEstate>>('/real-estates/list', {
                params: {
                    page,
                    perPage,
                    name,
                    type,
                },
            })
        ).data
    }

    public static async summary(types: REAL_ESTATE_TYPE[]): Promise<IRealEstateSummery[]> {
        return (
            await api.get<IRealEstateSummery[]>('/real-estates/summary', {
                params: {
                    types,
                },
            })
        ).data
    }

    public static async updateStatus(id: number, activeAction: IActiveAction): Promise<IActiveActionFinish> {
        return (await api.patch<IActiveActionFinish>(`/real-estates/${id}`, activeAction)).data
    }

    public static async create(values: FormData): Promise<IRealEstate> {
        return (await api.post<IRealEstate>('/real-estates', values)).data
    }

    public static async getOne(id: number): Promise<IRealEstate> {
        return (await api.get<IRealEstate>(`/real-estates/${id}`)).data
    }

    public static async update(id: number, values: FormData): Promise<IRealEstate> {
        return (await api.put<IRealEstate>(`/real-estates/${id}`, values)).data
    }
}
